import {Injectable} from "@angular/core";
import {AuthApiService} from "../auth/auth-api.service";
import {DisputeEvidenceSubmitRequestData} from "./dispute-evidence-submit-request.data";
import {DisputeViewData} from "./dispute-view.data";
import {HttpClient} from "@angular/common/http";
import {firstValueFrom} from "rxjs";

@Injectable()
export class DisputeService {

    constructor(private auth: AuthApiService, private http: HttpClient) {
    }

    async uploadEvidence(disputeId: string, file: File): Promise<string> {
        const formData: FormData = new FormData();
        formData.append("uploadedFileName", file);
        return firstValueFrom(this.http.post("/fonzie/dispute/" + disputeId + "/uploadEvidence/" + "customer_communication", formData, {
            headers: this.auth.getHttpHeaderOptions(),
            responseType: "text"
        }));
    }

    async submitEvidence(disputeEvidenceRequest: DisputeEvidenceSubmitRequestData): Promise<void> {
        return firstValueFrom(this.http.post<void>("/fonzie/dispute/" + disputeEvidenceRequest.disputeId + "/submitEvidence", disputeEvidenceRequest, {headers: this.auth.getHttpHeaderOptions()}));
    }

    async getDispute(disputeId: string): Promise<DisputeViewData> {
        return firstValueFrom(this.http.get<DisputeViewData>("/fonzie/dispute/" + disputeId, {headers: this.auth.getHttpHeaderOptions()}));
    }
}
